(function () {
    'use strict';

    TokenService.$inject = [
        '$window',
        'arrayService'
    ];

    function TokenService($window, arrayService) {
        var service = {
            generateToken: generateToken
        };

        return service;

        function generateToken(length) {
            const array = new Uint8Array(length || 40);
            const crypto = $window.crypto || $window.msCrypto;

            crypto.getRandomValues(array);

            return arrayService.toAlphaNumericString(array);
        }
    }

    module.exports = TokenService;
})();